import { useEffect, useRef, useState } from "react";
import { useApiWithHandling } from "./useApiWithHandling";

export const useTailNumbers = () => {
  const { get } = useApiWithHandling();

  const [tailNumbers, setTailNumbers] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchTailNumbers = async () => {
      setLoading(true);
      try {
        await get<string[]>("metadata/tail-numbers", {
          showLoader: false,
          showErrorSnackbar: false,
          showSuccessSnackbar: false,
          onSuccess: (data) => {
            setTailNumbers(data.data || []);
          },
          onError: () => {
            setTailNumbers([]);
          },
          onFinally: () => {
            setLoading(false);
          },
        }, 
        true);
      } catch {
        setTailNumbers([]);
        setLoading(false);
      }
    };

    fetchTailNumbers();
  }, [get]);

  return {
    tailNumbers,
    loading,
  };
};
